<template>
<div id="RentalContractInvoiceView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="web-right-sidebar"> <!--right sidebar-->
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab">
                <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Invoice Details</a>
                    <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                </div>
                <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                        <div class="list-view">
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Invoice #:</label>
                                <span class="col">{{invoice_number}}</span>
                            </div>

                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Invoice Date :</label>
                                <span class="col">{{invoice_date}}</span>
                            </div>

                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                <label class="col">Customer :</label>
                                <span class="col">{{customer}}</span>
                            </div>

                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Created Date :</label>
                                <span class="col">{{created_at}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Open Amount :</label>
                                <span class="col">{{open_amount}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Total Amount :</label>
                                <span class="col">{{total_amount}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                        <invoice-activity-log-list :activityLogVal="activityLogsTabValue"></invoice-activity-log-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
        <template v-if="cantAccessPage === true">
            <div class="page-name asset-view-page-name purchase-order-title">
                <div class="page-title"> # {{invoice_number}}</div>
                <div class="web-action-btn btn-groups text-right">
                    <button type="button" v-if="canAddCrm && deleted_at == null" class="btn btn-secondary" v-on:click="crmSection()" >
                        <i class="fp-agreement"> </i> {{crmBtnTitle}}
                    </button>
                    <template v-if="!isCrmSection">
                    <button v-if="deleted_at == null" type="submit" id="previewInvoiceBtn" v-on:click="previewInvoice()" class="btn btn-secondary"><i class="fp-invoice"></i> Preview Invoice
                    </button>
                    <button v-if="deleted_at == null" type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class="btn btn-secondary"><i class="fp-download"></i> Download PDF
                    </button>
                    <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                     <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </template>
                </div>
                <div class="mobile-action-btn elipse-btn">
                    <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'ListInvoice'}"> <i class="fp-back"></i> Back</router-link> -->
                     <button type="submit" class="btn btn-secondary" v-on:click.prevent="backInvoiceList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                        <i class="fp-ellipsis-v"></i>
                    </button>
                    <div id="myDropdown" class="dropdown-content">
                        <ul>
                            <li v-if="canAddCrm"><a  class="" href="javascript:void(0);" v-on:click="crmSection()" > CRM</a></li>
                            <li><a id="previewInvoiceBtn" v-on:click="previewInvoice()" class=""> Preview Invoice</a></li>
                            <li><a id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class=""> Download PDF</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div id="workorder-detail work-order-view-top" class="admin-page-content rc-invoice-view">
                    <template v-if="!isCrmSection">
                    <section class="internal-container border-top-table-fl">
                        <template v-if="invoiceItemsArr.length == 0 || invoiceItemsArr == undefined">
                            <div class="lineitem-main-section">
                            <h5>No Line Item Added</h5>
                            </div>
                        </template>
                        <template v-else>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="invoiceItemsArr != undefined">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Description</th>
                                            <th>Amount</th>
                                            <th class="text-right">Rate</th>
                                            <th class="text-right">Charge</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(invItems , itemKey) in invoiceItemsArr">
                                            <tr :key="'item0'+itemKey" v-if="invItems.unit_no != null">
                                                <td>Unit:&nbsp;{{invItems.unit_no}}</td>
                                                <td> &nbsp; </td>
                                                <td> &nbsp; </td>
                                                <td> &nbsp; </td>
                                            </tr>
                                            <template v-for="(invUnitItems , unititemKey) in invoiceItemsArr[itemKey]['unit']">
                                                <tr :key="'item1'+unititemKey">
                                                    <td>{{invUnitItems.charge_type}}</td>
                                                    <td> {{invUnitItems.inv_line_qty}} </td>
                                                    <td  class="text-right"> {{invUnitItems.inv_line_unit_price}} </td>
                                                    <td  class="text-right"> {{invUnitItems.invoice_line_total}} </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <tr>
                                            <td>  </td>
                                            <td> </td>
                                            <td class="text-right"> Total  </td>
                                            <td class="text-right"> {{total_before_tax}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Total Before Tax: </td>
                                            <td class="text-right"> {{total_before_tax}} </td>
                                        </tr>
                                        <tr>
                                            <td> Total Taxes: </td>
                                            <td class="text-right">{{total_taxes}}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total Due: </td>
                                            <td class="order-total text-right"> {{total_due}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> <!--Description section-->
                    </template>
                    <template v-else>
                        <!-- Invoice Crm -->
                        <div id="invoice-crm-list" class="admin-page-content invoice-view list-view">
                            <template v-if="crmAdd">
                                <crm-create :fromModule="invoiceObj"></crm-create>
                            </template>
                            <template v-else>
                                <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                                <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                    <div class="bg-white data-table p-0">
                                        <invoice-crm-list v-if="enableInvoiceCrm" :moduleVal="'invoice'" :moduleId="invoiceId"></invoice-crm-list>
                                    </div>
                                </section>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("invoice-activity-log-list", ActivityLogListView);
import CrmCreate from "@/components/CrmCreate.vue";
Vue.component("crm-create", CrmCreate);
export default {
    name: "RentalContractInvoiceView",
    components: {
        invoiceCrmList: () => import('@/components/CrmList.vue')
    },
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        invoiceItemsArr:[],
        permissions:[],
        cantAccessPage:"",
        loading:false,
        invoiceId : 0,
        invoice_number:'',
        deleted_at:'',
        invoice_date:'',
        company:'',
        user_number:'',
        customer:'',
        total_before_tax:'',
        total_taxes:'',
        total_due:'',
        activityLogsTabValue: "invoiceloadList",
        activetab: 1,
        isCrmSection:false,
        enableInvoiceCrm:false,
        canAddCrm:false,
        crmAdd:false,
        invoiceObj:{},
        crmBtnTitle:"CRM",
        fromUrl:"",
        from:"",
        created_at:"",
        open_amount:'',
        total_amount:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'add_crm') {
                    self.canAddCrm = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id.toString();
        if(this.$route.query.fromUrl != undefined && this.$route.query.fromUrl != ""){
          self.fromUrl = atob(this.$route.query.fromUrl);
        }
        if(this.$route.query.from == "customer"){
          self.from = this.$route.query.from;
        }
        //set value in invoice object for crm
        self.invoiceObj.module = "invoice";
        self.invoiceObj.invoice_id = this.$route.params.id;
        self.invoiceObj.flag = "add";
        self.invoiceObj.crm_id = "";
        self.getPermissions();
        self.loadInvoiceData();
    },
    metaInfo() {
        return {
            title: (this.invoice_number != "") ? this.invoice_number + " | Customer Invoice View | " +process.env.COPYRIGHT_NAME:"Customer Invoice View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/view",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data:{invoice_id:self.invoiceId},
                dataType: "json",
                success: function(data) {
                    self.loading = false;
                    //console.log(data.content[0]["id"]);
                    if (data.status == "success") {
                        if (data.content.length > 0) {
                            self.invoiceArr = data.content;
                            self.invoiceObj.customer_id = data.content[0].customer_id;
                            self.invoice_number = data.content[0].invoice_no;
                            self.deleted_at = data.content[0].deleted_at;
                            self.invoice_date = data.content[0].invoice_date;
                            self.created_at = data.content[0].created_at;
                            self.open_amount = data.content[0].open_amount;
                            self.total_amount = data.content[0].total;
                            self.company = data.content[0].company;
                            self.user_number = data.content[0].user_number;
                            self.customer = self.user_number + " | " + self.company;
                            self.total_before_tax = data.content[0].total;
                            self.total_taxes = data.content[0].total_taxes;
                            self.total_due = data.content[0].total;
                            if (data.content[0].item != undefined) {
                                self.invoiceItemsArr = data.content[0].item;
                            }else{
                                self.invoiceItemsArr = [];
                            }
                        }
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'rental-contract-invoice-view');
                }
            });
        },
        activityLogs(){

          var self = this;
          self.$root.$emit('activity_log_opted','invoice',self.invoiceId);
          self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
        generateInvoicePdf(){

            var self = this;

            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_origin:"system"
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'rental-contract-invoice-pdf');
                }
            });

        },
        previewInvoice() {
            var self = this;
            self.$router.push("/invoice/preview/" + self.invoiceId);
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableInvoiceCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableInvoiceCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = "";
            self.invoiceObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = crmId;
            self.invoiceObj.flag = "update";
        },
        backInvoiceList() {
            var self = this;
             var url = '/invoice/list';

            if ( self.fromUrl != ""  ) {
              if(self.from == 'customer'){
                var  selectTab = '?viewTab=invoice';
                url = self.fromUrl+selectTab;
              }else{
                url = self.fromUrl;
              }

            }

            self.redirectPageUrl(url);

        },
    }
}
</script>
<style scoped>
.text-right{
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/RentalContractInvoiceView.vue